var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:{'btn btn-mobile': true, 'mobile': !_vm.features.show_mobile_plus_btn_always},on:{"click":function($event){return _vm.openSideForm()}}},[_c('i',{staticClass:"icon icon-plus"})])}
var staticRenderFns = []

export { render, staticRenderFns }